<template>
    <div>
        <van-search
            style="margin-bottom:-5px;"
            v-model="searchKey"
            show-action>
            <template #action>
                <span style="padding-right:5px;" @click="onSearch">搜索</span>
            </template>
        </van-search>

        <van-dropdown-menu style="height:30px;">
            <van-dropdown-item title="状态筛选" ref="item">
                <van-switch-cell v-model="waitProcess" title="待受理" />
                <van-switch-cell v-model="processIng" title="处理中" />
                <van-switch-cell v-model="solved" title="已解决" />
                <van-switch-cell v-model="closed" title="已关闭" />

                <van-button block type="info" @click="onConfirm">确认</van-button>
            </van-dropdown-item>

            <van-dropdown-item :title="orderByTitle"
                @closed="on_orderBy_closed"
                v-model="orderBy"
                :options="orderByOption" />
        </van-dropdown-menu>
    </div>
</template>

<script>

// WAIT_PROCESS(2, "待受理"),
// PROCESSING(3, "处理中"),
// FINISH(5, "已解决"),
// CLOSED(6, "已关闭");
// [{"name":"待受理","value":2},{"name":"处理中","value":3},{"name":"已解决","value":5},{"name":"已关闭","value":6}]

export default {
    name : 'MobileTicketSearch',

    data() {
        return {
            searchKey : null,

            // 状态筛选
            waitProcess: true,
            processIng: true,
            solved: true,
            closed: false,

            // 排序
            orderByTitle: "更新时间倒序",
            orderBy: "`update_time` DESC",
            orderByOption: [
                { text: '更新时间', value: "`update_time` DESC" },
                { text: '创建时间', value: "`create_time` DESC" },
                { text: '优先级', value: "`order_priority` DESC" },
            ]
        };
    },

    methods : {
        on_orderBy_closed() {
            var _this = this;

            this.orderByOption.forEach(e => {
                if ( e.value == _this.orderBy ) {
                    _this.orderByTitle = e.text + "倒序";
                }
            });

            this.onSearch();
        },

        onConfirm() {
            this.$refs.item.toggle();

            this.onSearch();
        },

        onSearch() {
            var _ticketStatus = [];

            if ( this.waitProcess ) {
                _ticketStatus.push(2);
            }

            if ( this.processIng ) {
                _ticketStatus.push(3);
            }

            if ( this.solved ) {
                _ticketStatus.push(5);
            }

            if ( this.closed ) {
                _ticketStatus.push(6);
            }

            this.$emit('search', {
                key : this.searchKey,
                status : _ticketStatus,
                orderBy : this.orderBy
            });
        }
    }
}
</script>

<style>
    .van-dropdown-menu__item {
        justify-content: left;
        padding-left: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketSearch.vue